
/* Mechanical harvest URL's */
export const CULTIVATION_URLS = [
  { name: 'Products & Reports', url: '/cultivation/products', level: 2, iconColor: 'amber-text' },
  { name: 'Chemical Application', url: '/cultivation/chemicalApplication', level: 2, iconColor: 'teal-text' },
  { name: 'Fertilizer', url: '/cultivation/fertilizer', level: 2, iconColor: 'purple-text' },
  { name: 'Mowing', url: '/cultivation/mowing', level: 2, iconColor: 'cyan-text' },
  { name: 'Tree & Replant', url: '/cultivation/trees', level: 2, iconColor: 'green-text' }
];

export const PRODUCT_URLS = [
  { name: 'Products', url: '/cultivation/products', level: 1 },
  { name: 'Reports', url: '/cultivation/reports', level: 1 }
];

export const TREE_URLS = [
  { name: 'Tree Inventory', url: '/cultivation/trees', level: 1 },
  { name: 'Replants', url: '/cultivation/replants', level: 1 }
];

export const CHEMICAL_APP_URLS = [
  { name: 'Current Chemical Applications', url: '/cultivation/chemicalApplication', level: 1 },
  { name: 'Create & Edit Chemical Applications', url: '/cultivation/chemicalApplication/create', level: 1 }
];

export const FERTILIZER_URLS = [
  { name: 'Current Fertilizer Applications', url: '/cultivation/fertilizer', level: 1 },
  { name: 'Create & Edit Fertilizer Applications', url: '/cultivation/fertilizer/create', level: 3 }
];

export const MOWING_URLS = [
  { name: 'Current Mowing Work', url: '/cultivation/mowing', level: 1 },
  { name: 'Create & Edit Mowing Work', url: '/cultivation/mowing/create', level: 3 }
];

export const CHEMICAL_TYPES = [
  { label: 'Herbicide', val: 'Herbicide' },
  { label: 'Pesticide', val: 'Pesticide' },
  { label: 'Fungicide', val: 'Fungicide' },
  { label: 'Fertilizer', val: 'Fertilizer' },
  { label: 'Nutrient', val: 'Nutrient' },
  { label: 'Miticide', val: 'Miticide' },
  { label: 'Bactericide', val: 'Bactericide' },
  { label: 'Adjuvant', val: 'Adjuvant' }
].sort((a,b) => a.label < b.label ? 1 : -1);

export const YES_OR_NO = [
  { label: 'Yes', val: 1 },
  { label: 'No', val: 0 }
];

export const STATUS = [
  { label: 'Complete', val: 1 },
  { label: 'Incomplete', val: 0 }
];

export const ISSUE_OR_RECEIVE = [
  { label: 'Issue', val: 'I' },
  { label: 'Receive', val: 'R' }
];

export const APPLICATION_METHODS = [
  { label: 'Airblast', val: 'Airblast' },
  { label: 'Broadcast', val: 'Broadcast' },
  { label: 'Spot', val: 'Spot' }
];

export const UNITS_OF_MEASURE = [
  // length
  { label: 'ft', value: 'ft', type: 'length' },
  { label: 'sq.ft', value: 'sq.ft', type: 'length' },
  { label: 'yard', value: 'yard', type: 'length' },
  { label: 'm', value: 'm', type: 'length' },
  { label: 'km', value: 'km', type: 'length' },
  { label: 'mi', value: 'mi', type: 'length' },
  { label: 'acre', value: 'acre', type: 'length' },
  { label: 'hectare', value: 'hectare', type: 'length' },
  // mass
  { label: 'mg', value: 'mg', type: 'mass' },
  { label: 'g', value: 'g', type: 'mass' },
  { label: 'oz', value: 'oz', type: 'mass' },
  { label: 'kg', value: 'kg', type: 'mass' },
  { label: 'lb', value: 'lb', type: 'mass' },
  { label: 'ton', value: 'ton', type: 'mass' },
  // volume
  { label: 'ml', value: 'ml', type: 'volume' },
  { label: 'l', value: 'l', type: 'volume' },
  { label: 'kl', value: 'kl', type: 'volume' },
  { label: 'tsp', value: 'tsp', type: 'volume' },
  { label: 'Tbs', value: 'Tbs', type: 'volume' },
  { label: 'fl-oz', value: 'fl-oz', type: 'volume' },
  { label: 'cup', value: 'cup', type: 'volume' },
  { label: 'pnt', value: 'pnt', type: 'volume' },
  { label: 'qt', value: 'qt', type: 'volume' },
  { label: 'gal', value: 'gal', type: 'volume' }
];

export const LOCATIONS = [
  { val: '71', label: '71 - Kau' },
  { val: '72', label: '72 - Keaau' }
];
/*
  For FAQ cards. Use [color]-text for iconColor
*/
export const FAQS = [
  {
    title: 'Products & Reports FAQ',
    extra: 'Click for more information',
    icon: 'folder',
    iconColor: 'orange-text',
    cardColor: 'grey lighten-3',
    url: '/cultivation/products'
  },
  {
    title: 'Chemical Application FAQ',
    extra: 'Click for more information',
    icon: 'bug_report',
    iconColor: 'red-text',
    cardColor: 'grey lighten-3',
    url: '/cultivation'
  },
  {
    title: 'Fertilizer & Mowing FAQ',
    extra: 'Click for more information',
    icon: 'filter_vintage',
    iconColor: 'blue-text',
    cardColor: 'grey lighten-3',
    url: '/cultivation'
  },
  {
    title: 'Tree & Replant FAQ',
    extra: 'Click for more information',
    icon: 'local_florist',
    iconColor: 'green-text',
    cardColor: 'grey lighten-3',
    url: '/cultivation'
  },
];

export const REPORT_TYPES = [
  { label: 'Chemical Application', val: 'Chemical Application' },
  { label: 'Fertilizer', val: 'Fertilizer' },
  { label: 'Mowing', val: 'Mowing' },
  { label: 'Tree Replant', val: 'Tree Replant' },
  { label: 'Products', val: 'Products' },
  { label: 'Full Data Set', val: 'Full Data Set' }
];

/* END */



// WEBPACK FOOTER //
// ./src/cultivation/cult_constants.js